import styles from '@/app/(events)/events/freecshot-plus/index/style.module.scss';
import {forwardRef, useEffect} from 'react';
import clsx from 'clsx';

const FreecshotPlus = forwardRef(function MyLayer({data, handleClose}, ref) {
  const {
    eventStatus: eventResult,
    handleOnBroadcast,
    handleScrollTo,
  } = data ?? {};

  // dim 클릭 감지를 위한 useEffect
  useEffect(() => {
    const handleDialogClose = () => {
      if (eventResult.code === 1 || eventResult.code === -104) {
        location.reload();
      }
    };

    return () => {
      handleDialogClose();
    };
  }, []);

  if (!eventResult.code) return null;
  // 기본 다이얼로그 렌더링
  const renderResult = () => {
    switch (eventResult.code) {
      // 당첨
      case 1:
        return (
          <div className={styles.event_layer}>
            <div className={clsx(styles.result_area, styles.win)}>
              <strong className={styles.title}>
                축하합니다
                <em>
                  컴포즈 커피 아메리카노(ICE) 1잔 당첨
                  <i className={styles.italic}>!</i>
                </em>
              </strong>
              <p>
                선물권은 쪽지로 11월 중 모두 안내드리겠습니다.
                <br />
                <em>프릭샷 플러스에게 칭찬 한마디</em>
                <br />
                <span>
                  남겨주시면 경품까지 당첨<i className={styles.italic}>!</i>
                </span>
              </p>
            </div>
            <button
              type='button'
              className={styles.btn_close}
              onClick={() => {
                handleClose();
                location.reload();
              }}>
              닫기
            </button>
          </div>
        );

      // 선착순 마감
      case -104:
        return (
          <div className={styles.event_layer}>
            <div className={clsx(styles.result_area, styles.end)}>
              <strong className={styles.title}>
                SOLD OUT
                <em>선착순이 마감되었습니다 :</em>
              </strong>
              <p>
                아쉬워마세요<i className={styles.italic}>!</i>
                <br />
                <em>메세지를 보내면</em>
                <br />
                <span>이벤트 추첨대상이 될 수 있습니다.</span>
              </p>
            </div>
            <div className={styles.btn_area}>
              <button
                type='button'
                onClick={() => {
                  handleClose();
                  handleScrollTo('messageSection');
                }}>
                메세지 작성 후 경품 응모하기
              </button>
            </div>
            <button
              type='button'
              className={styles.btn_close}
              onClick={() => {
                handleClose();
                location.reload();
              }}>
              닫기
            </button>
          </div>
        );

      // 방송 시간 2시간 미만
      case -106:
        return (
          <div className={styles.event_layer}>
            <div className={clsx(styles.result_area, styles.fail)}>
              <strong className={styles.title}>
                방송 시간이
                <em>2시간 미만 입니다.</em>
              </strong>
              <p>
                <span>프릭샷 플러스로</span>
                <br />
                <em>2시간 이상 방송 진행해주세요.</em>
              </p>
            </div>
            <div className={styles.btn_area}>
              <button type='button' onClick={handleOnBroadcast}>
                프릭샷 플러스로 방송하기
              </button>
            </div>
            <button
              type='button'
              className={styles.btn_close}
              onClick={handleClose}>
              닫기
            </button>
          </div>
        );

      // 누적 방송 시간 미달
      case -105:
        return (
          <div className={styles.event_layer}>
            <div className={clsx(styles.result_area, styles.fail)}>
              <strong className={styles.title}>
                총 누적 방송시간
                <em>20시간이 달성되지 않았습니다.</em>
              </strong>
              <p>
                <span>방송시간 달성 후,</span>
                <br />
                <em>상품 받기를 다시 눌러주세요.</em>
              </p>
            </div>
            <div className={styles.btn_area}>
              <button type='button' onClick={handleOnBroadcast}>
                프릭샷 플러스로 방송하기
              </button>
            </div>
            <button
              type='button'
              className={styles.btn_close}
              onClick={handleClose}>
              닫기
            </button>
          </div>
        );

      default:
        return (
          <div className={styles.event_layer}>
            <div className={clsx(styles.result_area, styles.fail)}>
              <p>{eventResult?.message}</p>
            </div>

            <button
              type='button'
              className={styles.btn_close}
              onClick={handleClose}>
              닫기
            </button>
          </div>
        );
    }
  };

  return (
    <>
      {/* 기본 결과 다이얼로그 */}
      {renderResult()}
    </>
  );
});

export default FreecshotPlus;
